import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { AttatchFileTestComponent } from "../../../components/borrowSystem/BorrowForm/AttatchFileTestComponent";
// import { BorrowFormComponent } from '../../../../components/borrowSystem/BorrowForm/JuristicType/BorrowFormComponent';
import { Footer } from "../../../components/share/Footer";

export function AttatchFileTestContainer() {
  const titleName = "แผนที่ตั้งของสถานที่ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AttatchFileTestComponent />
      <Footer />
    </div>
  );
}
